import React, { ReactNode, cloneElement, useContext } from 'react'
import Container from '../../Container'
import { Cross } from '../../../assets/svg'
import Typography from '../../Typography'
import useTheme from '../../../hooks/useTheme'
import { ModalProps } from '../type'
import ModalContext from '../ModalContext'

const ModalTitle: React.FunctionComponent<
    Pick<ModalProps, 'hideCrossIcon' | 'onClose'> & { children: ReactNode }
> = ({ children }) => {
    const theme = useTheme()
    const { hideCrossIcon, onClose } = useContext(ModalContext)

    return (
        <Container
            display='flex'
            justifyContent='space-between'
            alignItems='center'
            width='100%'
        >
            <Typography variant='HM2'>{children}</Typography>
            {!hideCrossIcon && (
                <Container
                    cursor='pointer'
                    onClick={onClose}
                    display='flex'
                    alignItems='center'
                    marginLeft='auto'
                >
                    <Cross
                        width={22}
                        height={22}
                        strokeWidth={2.25}
                        crossColor={theme.color.text.heading}
                    />
                </Container>
            )}
        </Container>
    )
}

export default ModalTitle
